

























































import { Component, Mixins } from 'vue-property-decorator'
import GlobalMixin, { ALERT_TYPE } from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import FileData from '@/domain/FileData'
import CsvResponse from '@/domain/CsvResponse'
import CsvResponsesService from '@/service/CsvResponsesService'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
  },
})
export default class MemberReportCsvImport extends Mixins(GlobalMixin) {
  csvResponsesService = CsvResponsesService.instance

  errors: string[] = []
  importFileSelected = false
  importFile: FileData | undefined = undefined

  /**
   * 報告ファイルの登録ボタンのクリック
   */
  onImport(event: Event) {
    this.alertBarIsVisible = false
    if (this.importFile !== undefined) {
      this.errors = []
      const csvErrors = this.validateImportCsv(this.importFile.content)
      if (csvErrors.length !== 0) {
        /* CSVフォーマットエラー */
        this.errors = csvErrors
        this.alert("作業用ファイルの変換でエラーが発生しました", ALERT_TYPE.ERROR)
      } else {
        const csvData = this.parseImportCsv(this.importFile.content)
        /* データバリデーション */
        csvData.forEach((x, index) => {
          const rowErrors = x.validate()
          rowErrors.forEach(e => this.errors.push(`${index + 2} 行目: ${e}`))
        })
        if (this.errors.length === 0) {
        this.showLoading()
        this.csvResponsesService.upload(csvData)
          .then(() => {
            this.alert("保存しました", ALERT_TYPE.SUCCESS)
            this.hideLoading()
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error)
            this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
            this.hideLoading()
          })
        }
      }
    } else {
      event.stopPropagation()
    }
  }

  /**
   * インポートファイルの選択
   */
  onChangeImportFile(file: File | undefined) {
    this.importFile = undefined
    this.importFileSelected = false
    if (file !== undefined && file.name.toLowerCase().slice(-4) === ".csv") {
      const reader = new FileReader()
      reader.onload = () => {
        if (typeof reader.result === "string") {
          this.importFile = {filename: file.name, content: reader.result}
          this.importFileSelected = true
        }
      }
      reader.readAsText(file, "SJIS")
    }
  }

  /**
   * 報告ファイル(作業)データのCSVフォーマットバリデーション
   */
  private validateImportCsv(data: string): string[] {
    const errors: string[] = []
    data.split("\r\n").filter((x, index) => index === 0)
        .forEach(x => {
          if (x !== CsvResponse.getHeader().join(",")) {
            errors.push("ヘッダ行が違っています")
          }
        })
    if (errors.length === 0) {
      data.split("\r\n").map(x => x.length === 0 ? 101 : x.split(",").length)
          .forEach((x, index) => {
            if (x !== 101) {
              errors.push(`${index + 1} 行目の項目数が不正です`)
            }
          })
    }
    return errors
  }

  /**
   * CSV報告(作業)データのパース
   */
  private parseImportCsv(data: string): CsvResponse[] {
    return data.split("\r\n")
        .filter((x, index) => index !== 0)
        .filter(x => x.length > 0)
        .map(x => {
            const row = x.split(",")
            return new CsvResponse({
                requestId: row[0],
                status: row[1],
                lastModifiedAt: row[2],
                cancelOn: row[3],
                cancelReason: row[4],
                requestConfirmationOn: row[5],
                deliveryOn: row[6],
                reportNo: row[7],
                inspectionCompletionOn: row[8],
                requestRegistrationOn: row[9],
                recommendedScheduledOn: row[10],
                companyFactoryName: row[11],
                productName: row[12],
                category: row[13],
                edibleWeight: row[14],
                internalCapacity1: row[15],
                internalCapacity2: row[16],
                internalCapacity3: row[17],
                internalCapacity4: row[18],
                internalCapacity5: row[19],
                internalCapacity6: row[20],
                internalCapacity7: row[21],
                internalCapacity8: row[22],
                internalCapacity9: row[23],
                internalCapacity10: row[24],
                additive1: row[25],
                additive2: row[26],
                additive3: row[27],
                additive4: row[28],
                additive5: row[29],
                additive6: row[30],
                excludedParts: row[31],
                calorie100g: row[32],
                calorie100gUnit: row[33],
                calorie1meal: row[34],
                calorie1mealUnit: row[35],
                calorieInspectionMethod: row[36],
                protein100g: row[37],
                protein100gUnit: row[38],
                protein1meal: row[39],
                protein1mealUnit: row[40],
                proteinInspectionMethod: row[41],
                lipid100g: row[42],
                lipid100gUnit: row[43],
                lipid1meal: row[44],
                lipid1mealUnit: row[45],
                lipidInspectionMethod: row[46],
                carbohydrate100g: row[47],
                carbohydrate100gUnit: row[48],
                carbohydrate1meal: row[49],
                carbohydrate1mealUnit: row[50],
                carbohydrateInspectionMethod: row[51],
                sodium100g: row[52],
                sodium100gUnit: row[53],
                sodium1meal: row[54],
                sodium1mealUnit: row[55],
                sodiumInspectionMethod: row[56],
                moisture100g: row[57],
                moisture100gUnit: row[58],
                moisture1meal: row[59],
                moisture1mealUnit: row[60],
                moistureInspectionMethod: row[61],
                ash100g: row[62],
                ash100gUnit: row[63],
                ash1meal: row[64],
                ash1mealUnit: row[65],
                ashInspectionMethod: row[66],
                optionInspection1: row[67],
                optionInspection100g1: row[68],
                optionInspection100gUnit1: row[69],
                optionInspection1meal1: row[70],
                optionInspection1mealUnit1: row[71],
                optionInspectionMethod1: row[72],
                optionInspection2: row[73],
                optionInspection100g2: row[74],
                optionInspection100gUnit2: row[75],
                optionInspection1meal2: row[76],
                optionInspection1mealUnit2: row[77],
                optionInspectionMethod2: row[78],
                optionInspection3: row[79],
                optionInspection100g3: row[80],
                optionInspection100gUnit3: row[81],
                optionInspection1meal3: row[82],
                optionInspection1mealUnit3: row[83],
                optionInspectionMethod3: row[84],
                optionInspection4: row[85],
                optionInspection100g4: row[86],
                optionInspection100gUnit4: row[87],
                optionInspection1meal4: row[88],
                optionInspection1mealUnit4: row[89],
                optionInspectionMethod4: row[90],
                note1: row[91],
                note2: row[92],
                note3: row[93],
                note4: row[94],
                note5: row[95],
                note6: row[96],
                note7: row[97],
                note8: row[98],
                note9: row[99],
                note10: row[100],
        })
    })
  }
}
